import React, { type ReactNode } from 'react';

import MobileCardList from './MobileCardList';
import MobileSortHeader from './MobileSortHeader';
import type { IMobileColumn, IMobileRow, ISortByEntry, PrepareRow, RowClickCallback, SetSortBy } from './types';

interface IMobileTableProps {
    rows: IMobileRow[];
    prepareRow: PrepareRow;
    columns: IMobileColumn[];
    allowSort?: boolean;
    sortBy: ISortByEntry[];
    setSortBy: SetSortBy;
    emptyMessage?: ReactNode | string;
    rowClickCallback?: RowClickCallback;
    idPrefix: string;
}

const MobileTable = ({
    rows,
    prepareRow,
    columns,
    allowSort,
    sortBy,
    setSortBy,
    emptyMessage,
    rowClickCallback,
    idPrefix,
}: IMobileTableProps) => {
    return (
        <div data-testid={`${idPrefix}-mobile-table`}>
            {allowSort && (
                <MobileSortHeader
                    columns={columns}
                    sortBy={sortBy}
                    setSortBy={setSortBy}
                    idPrefix={idPrefix}
                />
            )}
            <MobileCardList
                rows={rows}
                prepareRow={prepareRow}
                emptyMessage={emptyMessage}
                rowClickCallback={rowClickCallback}
                idPrefix={idPrefix}
            />
        </div>
    );
};

export default MobileTable;
